import {HTHGameConfig} from "../HTHGameConfig";

export class HTHSymbolAnimation extends PIXI.Container {
    constructor() {
        super();
        this.name = "SymbolAnimation";
        const mainReelsMask: PIXI.Graphics = new PIXI.Graphics();
        mainReelsMask.name = "symbolAnimationMask";
        mainReelsMask.beginFill(0x3333FF, 0.5);
        mainReelsMask.drawRect(-HTHGameConfig.symbolWidth / 2, -HTHGameConfig.symbolHeight / 2, HTHGameConfig.symbolWidth * 6, HTHGameConfig.symbolHeight * 4);

        this.addChild(mainReelsMask);
        this.mask = mainReelsMask;
        this.position = HTHGameConfig.reelAreaPos;
    }
}